function numberWithCommas(x) {
    if (!x) {
        return '';
    }

    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function uppercaseWord(word) {
    if (!word) {
         return '';
    }

    return word.substring(0, 1).toUpperCase() + word.substring(1, word.length);
}

export { numberWithCommas, uppercaseWord }
